import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Clock, ArrowRight } from "lucide-react";
import usePublicContent from "../hooks/usePublicContent";
import { applySeoMeta } from "../lib/seoMeta";
import { usePublicPaths } from "../lib/localizedSlugs";
import { PublicNav, PublicFooter } from "../components/app/PublicChrome";

export default function BlogIndexPage() {
  const { t } = useTranslation();
  const pp = usePublicPaths();
  const articles = usePublicContent("blog");

  useEffect(() => {
    applySeoMeta({
      title: t("blogUi.indexTitle"),
      description: t("blogUi.indexDesc"),
      path: "/blog",
      ogImage: "/og-cover.jpg",
    });
  }, [t]);

  return (
    <div className="theme-swiss min-h-screen bg-slate-950 text-slate-100" data-testid="blog-index-page">
      <PublicNav />
      <section className="max-w-6xl mx-auto px-6 pt-14 pb-6">
        <div className="label-tech text-cyan-400 mb-3">// BLOG · {t("blogUi.tagline")}</div>
        <h1 className="font-display text-4xl sm:text-5xl font-bold text-white max-w-3xl">{t("blogUi.indexH1")}</h1>
        <p className="text-slate-400 mt-4 max-w-2xl">{t("blogUi.indexIntro")}</p>
      </section>
      <section className="max-w-6xl mx-auto px-6 py-8 grid grid-cols-1 md:grid-cols-2 gap-5">
        {(articles || []).map((a) => (
          <Link key={a.slug} to={pp.blog(a.slug)} className="tech-card p-6 group flex flex-col" data-testid={`blog-card-${a.slug}`}>
            <div className="flex items-center justify-between mb-3">
              <span className="label-tech text-cyan-400">{a.category}</span>
              <span className="text-xs text-slate-500 flex items-center gap-1"><Clock size={12}/> {a.readingTime} min</span>
            </div>
            <h2 className="font-display text-xl font-bold text-white group-hover:text-cyan-400 transition-colors mb-2">{a.title}</h2>
            <p className="text-sm text-slate-400 leading-relaxed flex-1">{a.excerpt}</p>
            <div className="mt-4 text-sm text-cyan-400 flex items-center gap-1">{t("blogUi.readMore")} <ArrowRight size={14}/></div>
          </Link>
        ))}
        {!articles && <div className="text-slate-500 py-20" data-testid="blog-loading">…</div>}
      </section>
      <PublicFooter />
    </div>
  );
}
